import React, { Component } from 'react'
import { Link } from 'react-router-dom';

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//css 
import '../../styles/dashboard/Home.css'

// assets
import Arrow from '../../../assets/icons/forward.svg'
import Back from '../../../assets/svg/back-arrow.svg'
import Check2 from '../../../assets/icons/pop-check.svg'


export default class CardPayment extends Component {

    
    state = {
        popUpClicked: false,
    };

    handleSubmit = event => {
        event.preventDefault();
        
        this.setState({ popUpClicked: true });
    }

    handleRemove = event => {
        event.preventDefault();

        this.setState({ popUpClicked: false });
        this.setState({popUpRemove: true})
        setTimeout(function(){ 
            document.querySelector('#rem-box').style.display = "none" 
        }, 1000);
    }


    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />

                {this.state.popUpClicked ? 
                    <div  id="rem-box" >
                        <div className="overlay animate__animated animate__fadeIn "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__slideInDown">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                               <h2>N24,000</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                               {/* {document.querySelector('#rem-box').style.display = "block"} */}
                            </div>
                        </section>
                    </div>
                : null}
                {this.state.popUpRemove === true && (
                    <div id="rem-box">
                        <div className="overlay animate__animated animate__fadeOut "></div>
                        <section className="popup">
                            <div className="popup-box animate__animated animate__backOutUp">
                                <div className="popup-img">
                                <img className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s" src={Check2} alt="" />
                                </div>
                                <h2>N24,000</h2>
                               <p className="popup-success">Wallet funded Successfully!</p>
                               <p onClick={this.handleRemove} className="popup-close">Close</p>
                            </div>
                        </section>
                    </div>
                )}


                <section className="home">
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/homefundwallet">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Card Payment </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <Link to="/dashboard/homefundwallet" className="right-e"><p className="ash"> Fund Wallet </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> Card Payment</span></p>
                            </div>
                            <div className="cardpayment-box">
                                <form onSubmit={this.handleSubmit} className="cardpayment-form">
                                    <div className="p2p-inputs">
                                        <input type="text" placeholder="Amount"/>
                                    </div>
                                    <div className="p2p-inputs">
                                        <input type="text" placeholder="Card Number"/>
                                    </div>
                                    <div className="cardinfos-box">
                                        <input className="carddate-input right-m2" type="text" placeholder="MM/YY" maxLength="5" />
                                        <input className="cardcode-input" type="text" placeholder="CVV" maxLength="3" />
                                    </div>
                                    <button className="cardinfo-submit" type="submit">Fund Wallet</button>
                                </form>
                            </div>
                            
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
